module.exports = {
	"it": {
		"help-tool": {
			"button-text": "Aiuto",
			"support-button": "Ottieni supporto",
			"support-page": {
				"create-ticket": {
					"title": "Ottieni supporto",
					"instructions": "Invia una richiesta, ti risponderemo entro 1 giorno lavorativo.",
					"related-content": {
						"title": "Questi strumenti potrebbero aiutarti a risolvere il tuo problema"
					},
					"fields": {
						"mid": {
							"label": "Seleziona negozio",
							"validation": "Negozio necessario"
						},
						"phoneNumber": {
							"label": "Numero di telefono (opzionale)"
						},
						"topic": {
							"question": "A cosa si riferisce la sua domanda?",
							"label": "Seleziona un argomento",
							"validation": "Argomento necessario",
							"options": {
								"orders": "Ordini",
								"settlements": "Liquidazioni",
								"agreements": "Accordi",
								"others": "Altro"
							}
						},
						"subject": {
							"label": "Oggetto",
							"validation": "Oggetto necessario"
						},
						"description": {
							"label": "Messaggio",
							"validation": "Descrizione necessaria"
						},
						"attachment": {
							"label": "Aggiungi allegati",
							"button": "Carica",
							"info": "Aggiungere schermate ci aiuterà a risolvere questo problema più rapidamente.",
							"supportedFileTypes": "Tipi di file supportati: .png, jpg, .pdf",
							"error": "La dimensione totale dei file non può eccedere i {maxSize} MB"
						}
					},
					"submit": "Invia richiesta",
					"service-unavailable-error": "Oh, no! Si è verificato un problema, riprova in alcuni minuti. Se questo persiste, {link} per richiedere assistenza.",
					"generic-error": "Non è stato possibile elaborare la tua richiesta. I nostri sistemi hanno al momento problemi di comunicazione. Prova ad aggiornare la pagina, o riprova più tardi. Se questo problema persiste, {link} per richiedere assistenza.",
					"contact-link": "contattaci"
				},
				"view-ticket": {
					"title": "Completato tutto!",
					"details": "Abbiamo ricevuto la tua richiesta. Riceverai una risposta entro 1 giorno lavorativo. Ecco il riepilogo dei tuoi dati:",
					"ticket": "Richiesta n. {ticketId}",
					"email": "Email: {email}",
					"status": "Puoi tracciare lo stato nella nostra pagina di Supporto",
					"track": "Traccia stato"
				}
			},
			"header": {
				"homeLink": "Ripristina"
			},
			"home": {
				"greeting": "Buongiorno {givenName}! Come possiamo essere d’aiuto?",
				"topics": "In cosa possiamo aiutarti?"
			},
			"topics": {
				"expandButton": "Altro"
			},
			"feedback": {
				"title": "È stata una risposta utile?",
				"optionYes": "Sì, è stata utile",
				"optionNo": "No, ho bisogno di ulteriore aiuto",
				"positiveFeedback": "Grazie per il tuo feedback positivo, questo ci aiuta molto ad offrire articoli più pertinenti per il futuro."
			},
			"freeTextFeedback": {
				"title": "Aiutaci a migliorare",
				"placeholder": "Perché non hai trovato utili questi contenuti?",
				"submitButton": "Invia",
				"feedbackMessage": "Grazie per il tuo feedback, questo ci aiuta molto ad offrire articoli più pertinenti per il futuro."
			},
			"relatedContent": {
				"title": "Contenuti correlati"
			},
			"search": {
				"buttonLabel": "Ricerca",
				"input": "Ricerca articoli…",
				"loading": "Caricamento…",
				"results": {
					"contact": "Non riesci a trovare l’aiuto di cui hai bisogno?",
					"empty": "Spiacenti, non sono stati trovati risultati per la tua richiesta. Prova a cercare un termine differente.",
					"singleTopicFound": "Abbiamo trovato 1 argomento",
					"multipleTopicsFound": "Abbiamo trovato {count} argomenti",
					"singleArticleFound": "Abbiamo trovato 1 articolo",
					"multipleArticlesFound": "Abbiamo trovato {count} articolo"
				}
			},
			"contact": {
				"title": "Contatta",
				"channelsIntro": "Contattaci così potremo essere d’aiuto.",
				"businessDetailsTitle": "I dati della tua attività",
				"businessDetailsName": "Nome attività",
				"businessDetailsEmail": "Email",
				"businessDetailsMid": "Merchant ID",
				"phone": {
					"title": "Chiamaci",
					"paragraph": "Puoi chiamarci durante l’orario di lavoro nei giorni infrasettimanali. Se ti trovi in Svezia o nel Regno Unito, puoi anche chiamarci durante i fine settimana, tra le 10:00 e le 16:00."
				},
				"email": {
					"title": "Scrivici un’email",
					"paragraph": "Invia un’email, risponderemo il prima possibile."
				}
			},
			"errorBoundary": {
				"title": "Si è verificato un problema",
				"message": "Siamo molto spiacenti, si è verificato un errore. Puoi cliccare sul pulsante sottostante “Torna indietro” per ritornare allo strumento di aiuto oppure sul pulsante “Supporto” per contattarci.",
				"resetButton": "Torna indietro",
				"errorId": "ID errore: {errorId}"
			},
			"tour": {
				"prev": "Precedente",
				"next": "Avanti",
				"done": "Fatto"
			},
			"notAvailableMobile": {
				"title": "Non disponibile",
				"buttonBack": "Indietro",
				"paragraph": "Questo contenuto non è disponibile per il tuo dispositivo. Prova ad aprirlo su un dispositivo dallo schermo più grande, quale un computer."
			},
			"shareButton": {
				"title": {
					"article": "Condividi un link dettagliato a questo articolo",
					"topic": "Condividi un link dettagliato a questo argomento",
					"tour": "Condividi un link dettagliato a questa visita"
				},
				"radioItemHome": "Home dell’app",
				"descriptionHome": "Apre l’articolo di aiuto sulla pagina Home del Portale Merchant",
				"radioItemCurrent": "Pagina attuale",
				"descriptionCurrent": "Apre l’articolo di aiuto sulla pagina attuale"
			},
			"marketSelector": {
				"whichMarketToContact": "Quale mercato vorresti contattare?"
			}
		},
		"orientation": {
			"title": "Impara a…"
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Ciao {name}! 👋 Sono il tuo assistente Klarna.",
				"whatDoYouNeedHelpWithPart2": "Posso aiutarti a chiarire i tuoi dubbi in meno di 5 minuti.",
				"whatDoYouNeedHelpWithPart3": "Cosa posso fare per te?",
				"selectSupportChannel": "Seleziona un canale per contattare il nostro servizio di assistenza.",
				"selectPayoutIssue": "Molto bene! Vai avanti e seleziona un problema relativo ai pagamenti 👇",
				"selectOrderIssue": "Molto bene! Vai avanti e seleziona un problema relativo agli ordini 👇",
				"capturedOrders": "Hai degli ordini {link1}?",
				"capturedOrdersLink1": "acquisito",
				"notPaidOrder": {
					"isScheduleFollowed": "Il tuo {link1} (incluso il ritardo di pagamento) è stato rispettato?",
					"isScheduleFollowedLink1": "programmazione di pagamento",
					"isHoldbackOrDebt": "Se la data prevista per il ritardo di pagamento è passata, controlla il tuo {link1}. È presente qualche trattenuta o qualche debito dovuto a rendimenti/storni?",
					"isHoldbackOrDebtLink1": "ultimo file di liquidazione"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Verifica la data di acquisizione degli ordini che prevedevi venissero pagati e considera il ritardo di pagamento. Puoi trovare i tuoi ordini in {link1}. Gli ordini in attesa di pagamento sono stati acquisiti?",
					"isScheduleFollowedLink1": "qui"
				},
				"changePaymentFrequency": "Hai avuto più di 30 ordini acquisiti al mese per più di 3 mesi?",
				"whenWillGetPaid": "La data di pagamento dipenderà dal tuo programma di pagamento e dal ritardo di pagamento indicato nel tuo contratto (Termini e Condizioni). Se non hai la certezza di quale sia la tua configurazione di pagamento, puoi controllarla in {link1}. Il programma di pagamento (e il ritardo di pagamento) è stato rispettato?",
				"whenWillGetPaidLink1": "Liquidazioni",
				"thatHelped": "Grazie per il tuo feedback. positivo. È molto importante per continuare ad offrire un aiuto sempre più preciso in futuro. 😀",
				"orders": {
					"haveUncapturedOrdersPart1": "Ho capito! Hai degli ordini da acquisire?",
					"haveUncapturedOrdersPart2": "Se non sai come verificarlo, vai in {link1}.",
					"haveUncapturedOrdersPart2Link1": "questa pagina",
					"expirationDateSurpassed": "La data di scadenza è passata? (solitamente 28 giorni)",
					"customerCreditPaymentMethod": "Il cliente ha scelto come metodo di pagamento fattura, conto o addebito diretto?",
					"isOrderCaptured": "L’ordine è {link1}?",
					"isOrderCapturedLink1": "acquisito"
				}
			},
			"options": {
				"payout": "Pagamento",
				"orders": "Ordini",
				"otherIssue": "Altri problemi",
				"whenPaidOrderNext": "Quando riceverò il prossimo pagamento?",
				"notPaidOrder": "Non ho ricevuto il pagamento",
				"paidWrongAmount": "Ho ricevuto il pagamento ma l’importo non era corretto",
				"changeHowOftenPaid": "Vorrei cambiare la frequenza con cui ricevo i pagamenti",
				"dontKnowHowToCaptureOrder": "Non so come fare per acquisire un ordine",
				"missedCaptureDeadline": "Il periodo utile per l’acquisizione di un ordine è scaduto",
				"needToRefundAnOrder": "Devo rimborsare un ordine",
				"yes": "Sì",
				"no": "No",
				"partially": "Parzialmente",
				"iNeedMoreHelp": "Ho bisogno di ulteriore aiuto",
				"thatHelped": "Questo mi è stato d’aiuto",
				"contactSupportChannel": "Contatta l’assistenza"
			},
			"explanations": {
				"noCapturedOrders": "Per prima cosa, devi {link1}. Una volta che l’ordine è acquisito, provvederemo a pagare l’importo sul tuo conto bancario. Eventuali commissioni, resi ed altri addebiti saranno scalati da questo importo.",
				"noCapturedOrdersLink1": "acquisisci un ordine",
				"feesReturnsHoldbacks": "Eventuali commissioni, resi ed altri addebiti potrebbero essere scalati da questo importo. Verifica se hai trattenute o debiti relativi a resi/storni in {link1}.",
				"feesReturnsHoldbacksLink1": "ultimo file di liquidazione",
				"notPaidOrder": {
					"scheduleFollowed": "Una volta che un ordine è acquisito, pagheremo l’importo sul tuo conto bancario in base al tuo programma di pagamento. Eventuali commissioni, resi ed altri addebiti saranno scalati da questo importo. Controlla il valore del tuo pagamento in {link1}.",
					"scheduleFollowedLink1": "ultimo file di liquidazione",
					"noHoldback": "Verifica di aver registrato correttamente i dettagli del tuo conto per la valuta del pagamento {link1}.",
					"noHoldbackLink1": "qui",
					"withHoldback": "Se il valore degli ordini acquisiti supera il debito, verifica di aver registrato correttamente i dettagli del tuo conto per la valuta del pagamento {link1}.",
					"withHoldbackLink1": "qui"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Riceverai il pagamento successivo in base al tuo programma di pagamento e al ritardo di pagamento."
				},
				"changePaymentFrequency": {
					"isAble": "Procedi contattando la nostra assistenza attraverso i seguenti canali.",
					"isUnable": "Purtroppo non disponi dei requisiti necessari per modificare il tuo programma dei pagamenti."
				},
				"orders": {
					"uncapturedDynamicYes": "Ho trovato {number} ordini non acquisiti.",
					"uncapturedDynamicNo": "Non hai ordini da acquisire",
					"uncapturedYesPart1": "È ora di acquisire questi ordini! Per procedere con l’acquisizione:",
					"uncapturedYesPart2": "1. Vai alla pagina dell’ordine {link1}.",
					"uncapturesYesPart2Link1": "facendo clic qui",
					"uncapturedYesPart3": "2. Fai clic sul riferimento di Klarna dell’ordine che desideri acquisire",
					"uncapturedYesPart4": "3. Scegli gli articoli o aggiungi un importo da acquisire",
					"uncapturedYesPart5": "4. Premi su “Acquisisci”",
					"uncapturedNoPart1": "Per poter acquisire un ordine devi prima avere degli ordini da acquisire.",
					"uncapturedNoPart2": "Acquisire un ordine significa confermare che un ordine è stato spedito al cliente. Questa operazione dovrebbe sempre avvenire il giorno stesso in cui un ordine viene spedito. L’acquisizione di un ordine è importante anche per indicarci di effettuare il pagamento di quell’ordine. Ulteriori informazioni su come acquisire un ordine {link1}.",
					"uncapturedNoLink1": "qui",
					"customerCreditPaymentMethodNo": "Purtroppo non possiamo estendere la data di scadenza di un ordine già scaduto. Dovrai necessariamente ricreare l’ordine.",
					"expirationDateSurpassedYes": "Se devi estendere la data di scadenza di un ordine e hai bisogno di aiuto, contatta la nostra assistenza tramite uno dei seguenti canali.",
					"expirationDateSurpassedNo": "Vai su {link1}. Seleziona l’ordine spuntando la casella accanto al numero di riferimento Klarna. Clicca su “Estendi data di scadenza” e conferma la tua richiesta.",
					"expirationDateSurpassedNoLink1": "Ordini > Da acquisire",
					"isOrderCapturedYesPart1": "Seleziona gli articoli da rimborsare e clicca su “Rimborsa”. Puoi anche cliccare su “Rimborsa” e inserire l’importo che desideri rimborsare. Scegli quello che preferisci.",
					"isOrderCapturedYesPart2": "Il cliente riceverà il rimborso dell’importo già pagato entro 2-5 giorni lavorativi. Vedrai poi questo importo dedotto dal tuo prossimo pagamento.",
					"isOrderCapturedNo": "Se hai un ordine non acquisito che non vuoi spedire, puoi {link1} l’intero ordine. Vai su {link2} e fai clic su “Annulla ordine”.",
					"isOrderCapturedNoLink1": "annulla",
					"isOrderCapturedNoLink2": "pagina dell’ordine",
					"refundPartiallyCaptured": "Se hai parzialmente acquisito l’ordine per gli articoli spediti e non intendi evadere il resto, puoi revocare la parte dell’ordine non acquisita. Vai su {link1}, fai clic su “Altre azioni” e seleziona “Revoca”.",
					"refundPartiallyCapturedLink1": "pagina dell’ordine"
				}
			},
			"messages": {
				"sorryToHearThat": "Mi dispiace non esserti stato d’aiuto. A breve sarai reindirizzato per contattare il nostro supporto."
			},
			"button": {
				"label": "Richiedi supporto"
			},
			"contact": {
				"chat": "Chatta con un incaricato",
				"ticket": "Apri un ticket",
				"times": {
					"minutes": "Tempo di attesa: {time} minuto/i",
					"hours": "Tempo di attesa: {time} ora/e",
					"days": "Tempo di attesa:{time} giorno/i"
				}
			}
		}
	}
};